import { Component } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { CropperPosition, Dimensions, ImageCroppedEvent, ImageTransform, LoadedImage } from 'ngx-image-cropper';


@Component({
  selector: 'app-image-cropper',
  templateUrl: './image-cropper.component.html',
  styleUrls: ['./image-cropper.component.css']
})
export class ImageCropperComponent {

  constructor(private sanitizer: DomSanitizer
  ) {

  }

  // -----------------Image Crop Function--------------------------
  showCropper = false;
  loading = false;
  croppedImage: SafeUrl = '';

  imageChangedEvent: Event | null = null;
  imageURL?: string;

  hidden = false;
  disabled = false;
  alignImage = 'center' as const;
  roundCropper = false;
  backgroundColor = 'grey';
  allowMoveImage = false;
  hideResizeSquares = false;
  canvasRotation = 0;
  aspectRatio = 4 / 3;
  containWithinAspectRatio = false;
  maintainAspectRatio = false;
  cropperStaticWidth = 0;
  cropperStaticHeight = 0;
  cropperMinWidth = 0;
  cropperMinHeight = 0;
  cropperMaxWidth = 0;
  cropperMaxHeight = 0;
  resetCropOnAspectRatioChange = true;
  cropper?: CropperPosition;
  transform: ImageTransform = {
    translateUnit: 'px',
    scale: 1,
    rotate: 0,
    flipH: false,
    flipV: false,
    translateH: 0,
    translateV: 0
  };



  fileChangeEvent(event: Event): void {
    this.loading = true;
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl || event.base64 || '');
    const base64 = event.base64;
    if (!base64) return;
    // Convert Base64 to File
    const file = this.base64ToFile(base64, this.imageName);

    this.croppedImageFile = file;
  }

  imageLoaded() {
    this.showCropper = true;
    console.log('Image loaded');
  }

  cropperReady(sourceImageDimensions: Dimensions) {
    console.log('Cropper ready', sourceImageDimensions);
    this.loading = false;
  }

  loadImageFailed() {
    console.error('Load image failed');
  }

  transformChange(transform: ImageTransform) {
    console.log('transform changed', transform);
  }

  rotateLeft() {
    this.loading = true;
    setTimeout(() => { // Use timeout because rotating image is a heavy operation and will block the ui thread
      this.canvasRotation--;
      this.flipAfterRotate();
    });
  }

  rotateRight() {
    this.loading = true;
    setTimeout(() => {
      this.canvasRotation++;
      this.flipAfterRotate();
    });
  }

  moveLeft() {
    this.transform = {
      ...this.transform,
      translateH: this.transform.translateH! - 1
    };
  }

  moveRight() {
    this.transform = {
      ...this.transform,
      translateH: this.transform.translateH! + 1
    };
  }

  moveDown() {
    this.transform = {
      ...this.transform,
      translateV: this.transform.translateV! + 1
    };
  }

  moveUp() {
    this.transform = {
      ...this.transform,
      translateV: this.transform.translateV! - 1
    };
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH,
      translateH: 0,
      translateV: 0
    };
  }

  flipHorizontal() {
    this.transform = {
      ...this.transform,
      flipH: !this.transform.flipH
    };
  }

  flipVertical() {
    this.transform = {
      ...this.transform,
      flipV: !this.transform.flipV
    };
  }

  resetImage() {
    this.canvasRotation = 0;
    this.cropper = undefined;
    this.maintainAspectRatio = false;
    this.transform = {
      translateUnit: 'px',
      scale: 1,
      rotate: 0,
      flipH: false,
      flipV: false,
      translateH: 0,
      translateV: 0
    };
  }

  zoomOut() {
    this.transform = {
      ...this.transform,
      scale: this.transform.scale! - .1
    };
  }

  zoomIn() {
    this.transform = {
      ...this.transform,
      scale: this.transform.scale! + .1
    };
  }

  updateRotation(rotate: number) {
    this.transform = {
      ...this.transform,
      rotate
    };
  }

  toggleAspectRatio() {
    this.aspectRatio = this.aspectRatio === 4 / 3 ? 16 / 5 : 4 / 3;
  }

  toggleBackgroundColor() {
    this.backgroundColor = this.backgroundColor === 'red' ? 'blue' : 'red';
  }

  cancelCropping() {
    // Logic to cancel cropping and reset the cropper
    this.resetCropper();

  }
  public croppedImageFile: File | null = null;

  resetCropper() {
    this.imageChangedEvent = null;
    this.showCropper = false;
    this.croppedImage = '';
    this.imageId = '';
    this.croppedImageFile = null;

  }

  private base64ToFile(base64: string, filename: string): File {
    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)![1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }


  public entryform: any = {
    data: { id: 0 }, //form data
  };
  public saveCroppedImage() {
  }
  // public saveCroppedImage() {

  //   let _self = this;
  //   if (!this.croppedImageFile) {
  //     alert('No cropped image available to save.');
  //     return;
  //   }

  //   // if (this.croppedImageFile) {
  //   //   const reader = new FileReader();
  //   //   reader.onload = () => {
  //   //     this.imagePreview = reader.result; // Set the image preview
  //   //   };
  //   //   // reader.readAsDataURL(file); // Convert the file to base64 URL
  //   // }

  //   const code = this.imageCode;
  //   let imageId = this.imageId;

  //   let url = this.getAPIBaseUrl("doc/" + this.entryform.data['id'] + "/" + this.imageId + "/" + code);

  //   const param = {
      
  //   };

  //   this.locator.http.postMutipart(
  //     url,
  //     param,
  //     this.croppedImageFile,
  //     (res: any, error: any) => {
  //       if (error) {
  //         alert(error);
  //         return;
  //       }
  //       _self.entryform['error'] = !res.success;
  //       _self.entryform['message'] = res.message;
  //       _self.entryform['inputerror'] = res.result['inputerror'];
  //       if (res.success) {
  //         this.entryform['message'] = 'File is uploaded successfully.';
  //         this.entryform.data[code] = res.result.data[code];
  //      //   this.changeDoc();
  //        // this.getDocThumbnail(this.form.data[code]);
  //       }
  //     }
  //   );

  //   this.resetCropper();
  // }

  public imageId: any = 0;
  public imageCode: any;
  public imageName: any;
  /**
   * Upload Image
   * @param event
   * @param code
   * @param imageId
   */
  public onFileChanged(event: any) {
    // Show the cropper

    this.fileChangeEvent(event);


    const fileObj = event.target.files[0];
    this.imageName = fileObj['name'];
    // this.imageId = imageId;
    //this.imageCode = code;

  }

  resetFileInput(fileInput: HTMLInputElement): void {
    fileInput.value = ''; // Reset the file input
    this.imageName = null; // Clear the file name
    console.log('File input reset');
  }

  imageData(code: string, imageId: any) {
    if (imageId === null || imageId === undefined || imageId === '') {

      imageId = 0;

    }

    this.imageId = imageId
    this.imageCode = code;
    console.log(this.imageId)
  }
}